import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $profileFeatureStore } from '@lib/store/profile';
import { PaletteUtils, RoutePaths } from '@shared/utils';
import type { UserWithPaymentInfo } from '@shared/api/rest/users';
import { ColorsEnum, Icon, Text } from '@shared/widgets';
import LockIcon from '@assets/icons/lock.svg';
import ExpandArrowIcon from '@assets/icons/expand-arrow.svg';
import ExpandInArrowIcon from '@assets/icons/expand-in-arrow.svg';

interface IUserItemHeadProps {
  user: UserWithPaymentInfo;
  setOpen?: () => void;
  open?: boolean;
}

export const UserItemHead = (props: IUserItemHeadProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  return (
    <div className='p-6 pb-8 relative'>
      <Link to={profileFeatureStore.data?.userManagement.viewUserProfileDetails ? RoutePaths.user.onNavigate(props.user.id) : ''}>
        <div className='max-w-[calc(100%-30px)] relative'>
          <div className='flex items-center min-w-0 shrink'>
            <div className='mr-3 flex-none overflow-hidden rounded-full w-12 h-12 flex items-center justify-center text-center relative select-none'>
              <div className='w-full h-full min-w-0 min-h-0 rounded bg-primary flex items-center justify-center relative z-[1]'>
                <Text weight='medium' size='xl' color={PaletteUtils.getColor(ColorsEnum.Black, ColorsEnum.White)} isUppercase>
                  {props.user.firstName[0]}
                </Text>
              </div>
              {props.user.locked && (
                <div className='absolute left-0 top-0 w-full h-full rounded bg-dark-wet-asphalt z-[3] flex items-center justify-center text-center'>
                  <Icon icon={<LockIcon width='24' height='24' />} color='red' />
                </div>
              )}
            </div>
            <div className={clsx('py-1 px-0 min-w-0 flex-1', props.user.locked && 'opacity-50')}>
              <Text className='overflow-hidden text-ellipsis capitalize' size='xl'>
                {props.user.firstName} {props.user.lastName}
              </Text>
              <Text size='sm' color={ColorsEnum.Gray}>
                {props.user.userType}
              </Text>
            </div>
          </div>
        </div>
      </Link>
      <div
        className='absolute right-6 top-6 text-2xl flex items-center justify-center text-center p-0 text-slate dark:text-gray-white cursor-pointer'
        onClick={props.setOpen}
      >
        <Icon icon={props.open ? <ExpandInArrowIcon /> : <ExpandArrowIcon />} />
      </div>
    </div>
  );
};
